import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { apiResponse } from 'src/app/models/apiResponse.model';
import { FieldsSelection } from 'src/app/models/apiParams.model';
import { BaseApiService } from '../base/base-api.service';

/**
 * Inspection Service - Handles inspection retrieval, reports, and updates
 */
@Injectable({ providedIn: 'root' })
export class InspectionService extends BaseApiService {
    private readonly basePath = '/inspection/v1/';

    constructor(http: HttpClient) {
        super(http);
    }

    /*-------------------------
    == INSPECTION CALLS ==
    -------------------------*/

    /**
     * Get all inspections
     */
    getInspections(limit?: number, page?: number): Observable<apiResponse> {
        return this.getAll<apiResponse>(this.basePath, {
            limit: limit ?? undefined,
            page: page ?? undefined
        });
    }

    /**
     * Get a single inspection by ID
     * Note: For inspection actions (approve, reject, plan, etc.), use ValuationService instead
     */
    getInspection(id: number, fields: FieldsSelection | null): Observable<apiResponse> {
        return this.getById<apiResponse>(this.basePath, id, { fields: fields || undefined });
    }

    /**
     * Update an inspection
     */
    updateInspection(id: number, data: any): Observable<apiResponse> {
        return this.putPath<apiResponse>(`${this.basePath}${id}`, data, 'json');
    }

    /**
     * Update inspection assessment
     */
    updateInspectionAssessment(id: number, data: any): Observable<apiResponse> {
        return this.putPath<apiResponse>(`${this.basePath}${id}/assessment`, data, 'json');
    }

    /*-------------------------
    == INSPECTION REPORT CALLS ==
    -------------------------*/

    /**
     * Get all inspection reports
     */
    getInspectionReports(): Observable<apiResponse> {
        return this.getAll<apiResponse>(`${this.basePath}report`);
    }

    /**
     * Get a single inspection report by ID
     */
    getInspectionReport(id: number): Observable<apiResponse> {
        return this.getById<apiResponse>(`${this.basePath}report/`, id);
    }
}
